export default "__VITE_ASSET__BLFqAIjN__"